// ======================================================================
// File Name       : ContentLinkCourseSelectedList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, InputGroup, Col, Row, Button, Table, FormControl } from 'react-bootstrap';


class ContentLinkCourseSelectedList extends Component {

  render() {
    const contentTypeArray = ['ビデオ', 'ドリル', '問題', 'ドキュメント', null, 'リンク'];
    const dataAffiliationType = ['内部', '外部'];
    const { addedContentList } = this.props;
    const itemList = Object.keys(addedContentList);
    return (
      <div>
        <Col sm={12} className="margin-top-10">
          <Col sm={2} className="margin-top-15 padding-left-right-clear">
            対象コンテンツ
          </Col>
          <Col sm={10} className="text-right padding-left-right-clear margin-bottom-5">
            <Button variant="default" onClick={this.props.handleRemoveAll}>コンテンツ一括削除</Button>
          </Col>
        </Col>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th>コンテンツ名</th>
              <th>コンテンツ種別</th>
              <th>外部</th>
              <th>コース名</th>
              <th>セクション名</th>
              <th width="60">操作</th>
            </tr>
          </thead>
          <tbody>
            {
              itemList.map((itemSecernId, index) => {
                const item = addedContentList[itemSecernId];
                return (
                  <tr key={index} className={item.addNew ? 'background_new_record' : ''}>
                    <td>{item.itemName}</td>
                    <td>{contentTypeArray[item.contentInfo.contentType]}</td>
                    <td>{dataAffiliationType[item.dataAffiliationType]}</td>
                    <td>{item.courseName}</td>
                    <td>{item.boxName}</td>
                    <td className="text-center">
                      <i
                        role="button"
                        className="bi bi-trash"
                        onClick={this.props.handleRemoveContent.bind(this, itemSecernId)}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>

        <Form.Group className="margin-top-20 text-center col-sm-12">
          <Button
            variant="default"
            className="btn-96 margin-right-10"
            onClick={this.props.onCancel}
          >
            戻る
          </Button>
          <Button
            variant="primary"
            className="btn-96"
            onClick={this.props.onOK}
          >
            OK
          </Button>
        </Form.Group>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { addedContentList } = state.csvDownload;
  return { addedContentList };
};
export default connect(mapStateToProps)(ContentLinkCourseSelectedList);

